<template>
	<div class="c-controls">
		<div class="c-slidecontrols">
			<button class="c-slidecontrols__prev" v-on:click.prevent="prev" v-bind:disabled="prevDisabled">
				<svg class="icon icon_vorige"><use xlink:href="#icon_vorige"></use></svg>
			</button>
			<button class="button button--control" v-on:click.prevent="next" v-bind:disabled="nextDisabled">
				Volgende slide <svg class="icon icon_next"><use xlink:href="#icon_next"></use></svg>
			</button>
		</div>
	</div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'ImagesControl',
	mixins: [BaseControl],
	props: {
		images: Array,
	},
	data() {
		return {
			currentIndex: 0,
		};
	},
	computed: {
		prevDisabled() {
			return this.currentIndex == 0;
		},
		nextDisabled() {
			return this.currentIndex + 1 >= this.images.length;
		},
	},
	methods: {
		prev() {
			if (this.currentIndex == 0) {
				return;
			}

			this.currentIndex--;
			this.subcommand('images.prev');
		},
		next() {
			if (!(this.currentIndex + 1 < this.images.length)) {
				return;
			}

			this.currentIndex++;
			this.subcommand('images.next');
		},
	},
	mounted() {
		console.log('images control mounted!');
	},
};
</script>

<style></style>
